/*
 * OktaVerification Messages
 *
 * This contains all the text for the OktaVerification scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.OktaVerification";

export default defineMessages(scope, {
  header: "Okta Verify",
});
